export default __webpack_public_path__ + "static/page-solutions-obesity-study-physical-background-e5b74088fe5ecb003dadac3febd858dd.jpg";